import React, { useState, useEffect } from "react";
import { Box, Skeleton } from "@mui/material";
import { downloadFile } from "@frontend/features/common/queries";

interface ChatVideoProps {
  fileId: string;
  size?: 'regular' | 'compact';
}

export const ChatVideo: React.FC<ChatVideoProps> = ({ fileId, size = 'regular' }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [videoSource, setVideoSource] = useState<string>();

  const dims = size === 'compact'
    ? { maxW: 120, maxH: 120, skW: 120, skH: 120 }
    : { maxW: 200, maxH: 200, skW: 200, skH: 200 };

  useEffect(() => {
    setIsLoading(true);
    if (fileId) {
      downloadFile(+fileId, true)
        .then((url: any) => {
          if (!url) return;
          setVideoSource(url);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [fileId]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
    >
      {isLoading ? (
        <Skeleton variant="rectangular" width={dims.skW} height={dims.skH} sx={{ borderRadius: 1 }} />
      ) : videoSource ? (
        <Box
          component="video"
          src={videoSource}
          controls
          sx={{
            maxWidth: dims.maxW,
            maxHeight: dims.maxH,
            objectFit: "contain",
            borderRadius: 1
          }}
        />
      ) : null}
    </Box>
  );
}; 
